import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BusinessIcon from "@mui/icons-material/Business";
import { Box, Button, IconButton, Tab, Tabs, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  columnData,
  getColorChange,
  ManageUserColumnData,
} from "../../common/constants/gridRowColumn";
import {
  useCompany,
  useDealer,
  useFleetList,
  useModel,
  useMovableColumn,
  useNewVehicle,
  usePagination,
  useReplacement,
  useSortableColumn,
  useUser,
} from "../../common/hooks";
import { useGlobalSearch } from "../../common/contexts";
import { DeleteDialog } from "../../components/DeleteDialog";
import { layoutStyle } from "../layout-ui/style";
import { TruckLoader } from "./truckLoader";
import {
  actionColumnFunction,
  checkFieldColumn,
  checkbox,
  ensureHeaderTooltip,
  getCompanyId,
  getDefaultColDef,
  onGridReady,
} from "../../common/constants/commonFunction";
import { sidebarMenu } from "../../common/constants/commonFunction";
import { FleetCsvUpload } from "../../components/FleetCsvUpload";
import { FleetHeaderButton } from "../../components/FleetHeaderButton";
import {
  CustomTabPanel,
  a11yProps,
} from "../../components/FleetTabPanelCustom";
import { TAB_CONTENT, TAB_VALUE } from "../../common/constants/popupMessage";
import { SpeakToTextButton } from "../../common/services/SpeakToTextButton";
import { localStorageItemNames } from "../../common/constants";
import { set } from "react-hook-form";
import { PageNameConstant } from "../../common/constants/PageNameConstant";
import { PopupBlock } from "../../components/PopupBlock";
import {
  applyActiveSortToColumns,
  getActiveSortRequest,
  getActiveSortRecord,
  onSortChanged,
  sortRowsByActiveSort,
} from "../../common/utils/sortingColumn";
import { DEALEAR_DEFAULT } from "../../common/constants/dealer-name";

export const FleetList = () => {
  const classes = layoutStyle();
  const [columnFinal, setColumnFinal] = useState([]);
  const [value, setValue] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowDataFinal, setRowDataFinal] = useState([]);
  const [open, setOpen] = useState(false);
  const [openTypeDialog, setOpenTypeDialog] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    fleetList,
    getFleetListApi,
    setEditData,
    setTotalCount,
    deletFleetListByIdApi,
    loading,
    multipleFleetDeleteApi,
    setFleetList,
    requireFields,
  } = useFleetList();
  const {
    setSelectedRow,
    setNewRowData,
    selectedRow,
    newRowData,
    setNewRowIndexData,
  } = useModel();
  const [page, setPage] = useState({ pageSize: 10000, page: 0 });
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteValue, setDeleteValue] = useState();
  const [addButtonDisabled, setAddButtonDisabled] = useState(false);
  const { companyNameHeader, dealerNameHeader } = useCompany();
  const [mpgNull, setMpgNull] = useState([]);
  const [companyId, setCompanyId] = useState();
  const [file, setFile] = useState();
  const [rows, setRows] = useState([]);
  const {
    fleetUpload,
    errorMessage,
    setErrorMessage,
    companyDealerId,
    setFleetUpload,
    setNewFleetNo,
    setMatchDealerName,
  } = useDealer();
  const userType = localStorage.getItem("type");
  const {
    setSelectedNav,
    columnChange,
    setColumnChange,
    popupBlock,
    setPopupBlock,
    setSidebarColumnPopup,
  } = useUser();
  const { state } = useLocation();
  const navigation = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [rowDataCSV, setRowDataCsv] = useState([]);
  const [originalColumn, setOriginalColumn] = useState(false);
  const { setToastClose, setNewVehicle } = useNewVehicle();
  const [gridApi, setGridApi] = useState(null);
  const { setReplacementList } = useReplacement();
  const [localSortedColumn, setLocalSortedColumn] = useState([]);
  const gridRef = useRef(null);
  const [movableColumnData, setMovableColumnData] = useState([]);
  const {
    getSortableColumnApi,
    sortableColumnData,
    createSortableColumn,
    updateViewSortableColumn,
  } = useSortableColumn();
  const {
    movableColumn,
    getMovableColumnApi,
    createMovableColumn,
    updateViewMovableColumn,
  } = useMovableColumn();
  // Use local state for sortedColumn to prevent cross-page contamination via shared context
  const sortedColumn = localSortedColumn;
  const setSortedColumn = setLocalSortedColumn;
  const {
    fleetPagination,
    setPagination,
    setFleetPagination,
    setMaintainancePagination,
    setFuelPagination,
    setFundingPagination,
  } = usePagination();

  const handleClose = () => {
    setOpen(false);
    setValue(0);
    setRows([]);
    setNewRowData([]);
    setFile(null);
    setErrorMessage("");
    setAddButtonDisabled(false);
    setMatchDealerName([]);
    setSelectedType("");
    setOpenTypeDialog(false);
  };

  const { globalSearchResult, setGlobalSearchResult } = useGlobalSearch();

  useEffect(() => {
    if (globalSearchResult && globalSearchResult.category === "Fleets") {
      setSearchValue(globalSearchResult.data.fleetNo);
      setGlobalSearchResult(null);
    }
  }, [globalSearchResult]);

  useEffect(() => {
    if (companyNameHeader) {
      let companyValue = getCompanyId(userType, companyNameHeader);
      setCompanyId(companyValue);
    }
  }, [companyNameHeader]);

  useEffect(() => {
    const searchData = fleetList?.filter((fleet) =>
      fleet?.fleetNo?.toLowerCase().includes(searchValue?.toLowerCase())
    );
    if (searchValue) {
      setRowDataFinal(
        sortRowsByActiveSort(searchData, getActiveSortRecord(sortableColumnData))
      );
    } else if (fleetList?.length > 0) {
      setRowDataFinal(
        sortRowsByActiveSort(fleetList, getActiveSortRecord(sortableColumnData))
      );
    } else {
      setRowDataFinal([]);
    }
  }, [searchValue, fleetList, sortableColumnData]);

  const defaultColDef = useMemo(
    () => ({ ...getDefaultColDef(), sortable: true }),
    []
  );

  useEffect(() => {
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fleetList,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });
    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fleetList,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });
    setErrorMessage("");
    setToastClose(false);
    setNewRowIndexData(null);
    setNewVehicle([]);
    setReplacementList([]);
    setSidebarColumnPopup("");
    setPagination(0);
    setMaintainancePagination(0);
    setFuelPagination(0);
    setFundingPagination(0);
  }, []);

  useEffect(() => {
    let companyValue = getCompanyId(userType, companyNameHeader);
    setColumnChange(false);
    setPopupBlock(false);
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fleetList,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: DEALEAR_DEFAULT.dealerId,
      },
    });
    const loadFleetList = async () => {
      const sortResponse = await getSortableColumnApi({
        filter: {
          userId: localStorage.getItem(localStorageItemNames.userID),
          pageName: PageNameConstant.fleetList,
          companyId: localStorage.getItem(localStorageItemNames.companyId),
          dealerId: DEALEAR_DEFAULT.dealerId,
        },
      });

      if (companyValue) {
        getFleetListApi({
          limit: page.pageSize,
          offset: page.page,
          userId: Number(localStorage.getItem(localStorageItemNames.userID)),
          companyId: companyValue,
          dealerId: DEALEAR_DEFAULT.dealerId,
          ...getActiveSortRequest(sortResponse),
        });
      } else {
        setRowDataFinal([]);
        setFleetList([]);
        setMpgNull([]);
      }
    };
    loadFleetList();
  }, [fleetUpload, companyNameHeader, dealerNameHeader, companyDealerId]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) {
      setOpenTypeDialog(true);
    }
  };

  useEffect(() => {
    const activeSort = getActiveSortRecord(sortableColumnData);
    if (state?.data && fleetList?.length === 0) {
      setRowDataFinal([...state.data]);
      setRows([...state.data]);
      setNewRowData([...state.data]);
    } else {
      if (fleetList?.length > 0) {
        let rowsMpg = [];
        fleetList?.map((items) => {
          if (items?.mpg === 0) {
            rowsMpg.push(items?.fleetNo);
          }
        });
        setMpgNull(rowsMpg);
        const filteredRows = searchValue
          ? fleetList.filter((fleet) =>
              fleet?.fleetNo?.toLowerCase().includes(searchValue.toLowerCase())
            )
          : fleetList;
        setRowDataFinal(sortRowsByActiveSort(filteredRows, activeSort));
      } else {
        setRowDataFinal([]);
      }
    }
  }, [fleetList, state, sortableColumnData, searchValue]);

  useEffect(() => {
    if (errorMessage == "empty") {
      setTotalCount(fleetList?.length);
      handleClose();
      setRows([]);
      setNewRowData([]);
      setFleetUpload(false);
    } else if (errorMessage) {
      // showToast(errorMessage)
    }
  }, [errorMessage]);

  const handleEditButton = (params) => {
    setEditData(params);
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FLEET_LIST,
        selectedContent: TAB_CONTENT.FLEET_LIST,
        data: params,
      },
    });
  };

  const onCellClicked = (event) => {
    let checkField = checkFieldColumn(event);
    if (checkField) {
      handleEditButton(event?.data);
    }
  };

  const handleDeleteButton = async (values) => {
    const fleetId = values?.fleetId
      ? [values?.fleetId]
      : values.map((item) => item?.fleetId);
    setDeleteOpen(true);
    if (Array.isArray(fleetId)) {
      setDeleteValue(fleetId);
    } else {
      setDeleteValue({ fleetId });
    }
  };

  const handleDelete = async () => {
    setDeleteOpen(false);
    let dealerId = dealerNameHeader?.id;
    if (Array.isArray(deleteValue)) {
      const ids = deleteValue;
      let payload = { ids, companyId, dealerId };
      await multipleFleetDeleteApi(payload);
    } else {
      let payload = {
        ids: deleteValue,
        companyId: companyId,
        dealerId: dealerId,
      };
      await multipleFleetDeleteApi(payload);
    }
    setDeleteValue(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNext = (event) => {
    if (columnChange) {
      setPopupBlock(true);
    } else {
      setSelectedNav(sidebarMenu.replacement);
      navigation("/strategic-replacement-plan");
    }
  };

  const handleOnClose = () => {
    setAnchorEl(null);
  };

  const handleRowSelection = (event) => {
    setFleetPagination(event?.api?.paginationGetCurrentPage());
    setSelectedRows(event.api.getSelectedNodes().map((node) => node.data));
    setSelectedRow(event.api.getSelectedNodes().map((node) => node.data));
  };

  useEffect(() => {
    setEditData({});
    setNewFleetNo(null);
  }, []);

  useEffect(() => {
    if (rowDataCSV?.length > 0) {
      setRows(rowDataCSV);
      setNewRowData(rowDataCSV);
    } else {
      setRows([]);
      setNewRowData([]);
    }
  }, [rowDataCSV]);

  useEffect(() => {
    if (
      requireFields?.length == 0 &&
      columnFinal?.length > 0 &&
      mpgNull?.length == 0
    ) {
      movableColumnData?.map((item) => {
        item["cellStyle"] = { background: "white", color: "black" };
      });
      setColumnFinal([...movableColumnData]);
    } else {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        handleDeleteButton: handleDeleteButton,
        deleteButton: true,
      });
      movableColumnData?.map((items) => {
        items["cellStyle"] = (params) => getColorChange(params);
      });
      setColumnFinal([...movableColumnData]);
    }
  }, [requireFields, movableColumnData, mpgNull]);
  const clearAllFilters = () => {
    // Clear all filters in the grid
    if (gridApi) {
      gridApi.setFilterModel(null);
    }
  };

  useEffect(() => {
    if (movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      const activeSort = getActiveSortRecord(sortableColumnData);
      columnParse = applyActiveSortToColumns(columnParse, activeSort);
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        handleDeleteButton: handleDeleteButton,
        deleteButton: true,
      });
      const filteredColumns = columnParse.filter(
        (col) => col.field !== "action"
      );
      filteredColumns?.map((items) => {
        items["cellStyle"] = (params) => getColorChange(params);
        const defaultMatch = columnData.find(c => c.field === items.field);
        if (defaultMatch) {
          items.minWidth = defaultMatch.minWidth;
          if (defaultMatch.comparator) {
            items.comparator = defaultMatch.comparator;
          }
        }
      });
      setMovableColumnData([...filteredColumns, actionColumn]);
    } else {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        handleDeleteButton: handleDeleteButton,
        deleteButton: true,
      });
      columnData?.map((items) => {
        items["cellStyle"] = (params) => getColorChange(params);
      });
      setMovableColumnData(
        applyActiveSortToColumns(
          [checkbox, ...columnData, actionColumn],
          getActiveSortRecord(sortableColumnData)
        )
      );
    }
  }, [columnData, movableColumn, sortableColumnData]);
  const handleColumnChange = (event) => {
    if (event?.column) {
      const cols = gridRef.current?.api?.getAllGridColumns();
      const colNamesIndex = cols?.map((items, index) => items?.colDef);
      setMovableColumnData(colNamesIndex);
      setColumnChange(true);
    }
  };
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (fleetPagination && gridRef?.current?.api) {
      gridRef?.current?.api?.paginationGoToPage(fleetPagination);
    }
  }, [fleetPagination, rowDataFinal]);
  return (
    <Box className={classes.mainFleetContent}>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }} p={0}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#1D4ED8",
                  height: 3,
                  borderRadius: 3,
                },
              }}
            >
              <Tab
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 700,
                  color: "#475569",
                  "&.Mui-selected": {
                    color: "#1D4ED8",
                  },
                }}
                label="Current Fleet Details"
                {...a11yProps(0)}
              />
              <Tab
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 700,
                  color: "#475569",
                  "&.Mui-selected": {
                    color: "#1D4ED8",
                  },
                }}
                label="Fleet Upload CSV / XLSX"
                {...a11yProps(1)}
              />
            </Tabs>
            <Box className={classes.notediv} sx={{ gap: "10px", display: "flex", flexWrap: "wrap", justifyContent: "flex-end", width: "auto" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  background: "rgba(248, 113, 113, 0.12)",
                  border: "1px solid rgba(248, 113, 113, 0.3)",
                  color: "#DC2626",
                  padding: "4px 14px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: 600,
                  boxShadow: "0 0 10px rgba(248, 113, 113, 0.08)",
                }}
              >
                <Box sx={{ width: 6, height: 6, bgcolor: "#DC2626", borderRadius: "50%", boxShadow: "0 0 6px rgba(220, 38, 38, 0.25)" }} />
                MPG not found in Government website
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  background: "rgba(250, 204, 21, 0.12)",
                  border: "1px solid rgba(250, 204, 21, 0.3)",
                  color: "#B45309",
                  padding: "4px 14px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: 600,
                  boxShadow: "0 0 10px rgba(250, 204, 21, 0.08)",
                }}
              >
                <Box sx={{ width: 6, height: 6, bgcolor: "#FACC15", borderRadius: "50%", boxShadow: "0 0 6px rgba(250, 204, 21, 0.25)" }} />
                Vehicle Model - closest match used
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Box className={classes.gridContantFleetListPage}>
          <Box>
            <span
              style={
                mpgNull?.length > 0
                  ? { color: "red" }
                  : { color: "transperent" }
              }
            >
              {mpgNull &&
                mpgNull?.length > 0 &&
                "MPG value is required for following fleets: "}
              {mpgNull &&
                mpgNull?.length > 0 &&
                mpgNull?.map((item) => {
                  return <span key={item}>{item ? item + " " : ""}</span>;
                })}
            </span>
          </Box>
          <FleetHeaderButton
            handleNext={handleNext}
            handleClick={handleClick}
            selectedRows={selectedRows}
            setSearchValue={setSearchValue}
            anchorEl={anchorEl}
            handleOnClose={handleOnClose}
            handleDeleteButton={handleDeleteButton}
            companyId={companyId}
            setSelectedRows={setSelectedRows}
            rowDataFinal={rowDataFinal}
            clearAllFilters={clearAllFilters}
            columnChange={columnChange}
            movableColumnData={movableColumnData}
            setMovableColumnData={setMovableColumnData}
            movableColumn={movableColumn}
            updateViewMovableColumn={updateViewMovableColumn}
            createMovableColumn={createMovableColumn}
            setColumnChange={setColumnChange}
            gridRef={gridRef}
            columnFinal={columnFinal}
            setSortedColumn={setSortedColumn}
            setColumnFinal={setColumnFinal}
            sortableColumnData={sortableColumnData}
            createSortableColumn={createSortableColumn}
            updateViewSortableColumn={updateViewSortableColumn}
            pageName={PageNameConstant.fleetList}
            mpgNull={mpgNull}
          />
          {loading ? (
            <TruckLoader />
          ) : (
            <AgGridReact
              ref={gridRef}
              className="ag-theme-quartz"
              onRowSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRows = rowDataFinal.filter((row) =>
                  selectedIDs.has(row.id)
                );
                setSelectedRows(selectedRows);
              }}
              rowSelection="multiple"
              suppressRowClickSelection
              onColumnMoved={(event) => handleColumnChange(event)}
              pagination={true}
              rowData={rowDataFinal}
              defaultColDef={defaultColDef}
              checkboxSelection
              columnDefs={ensureHeaderTooltip(columnFinal)}
              onSelectionChanged={handleRowSelection}
              onCellClicked={onCellClicked}
              onGridReady={(params) => onGridReady(params, setGridApi)}
            />
          )}
        </Box>
      </CustomTabPanel>
      {/* Fleet Type Selection Dialog */}
      <Dialog
        open={openTypeDialog}
        onClose={() => {
          setOpenTypeDialog(false);
          setValue(0); // Reset tab back to Current Fleet Details
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: (theme) => ({
            borderRadius: "16px",
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(148,163,184,0.12)' : 'rgba(160, 198, 232, 0.35)'}`,
            boxShadow: theme.palette.mode === 'dark' ? '0 16px 40px rgba(0,0,0,0.6)' : '0 16px 40px rgba(2, 6, 23, 0.08)',
            p: 1.5,
          }),
        }}
      >
        <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
          <Typography variant="h6" fontWeight={700} color="primary.main">
            Select Fleet Category
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Choose the type of Current Fleet Details you want to upload
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, py: 2, my: 2 }}>
          {/* Government Card/Button */}
          <Button
            variant="outlined"
            onClick={() => {
              setSelectedType("Government");
              setOpenTypeDialog(false);
              setOpen(true);
            }}
            sx={(theme) => ({
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.5,
              p: 3,
              my: 2,
              borderRadius: "12px",
              textTransform: "none",
              borderColor: theme.palette.mode === 'dark' ? 'rgba(148,163,184,0.2)' : 'rgba(160, 198, 232, 0.5)',
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(30,41,59,0.5)' : 'rgba(241, 245, 249, 0.5)',
              color: theme.palette.text.primary,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                borderColor: theme.palette.primary.main,
                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(29, 78, 216, 0.15)' : 'rgba(29, 78, 216, 0.06)',
                transform: "translateY(-4px)",
                boxShadow: theme.palette.mode === 'dark'
                  ? '0 8px 20px rgba(0,0,0,0.4)'
                  : '0 8px 20px rgba(29, 78, 216, 0.08)',
              },
            })}
          >
            <AccountBalanceIcon sx={{ fontSize: 44, color: "primary.main" }} />
            <Box>
              <Typography variant="subtitle1" fontWeight={700}>
                Government
              </Typography>
              {/* <Typography variant="caption" color="text.secondary">
                Replacement cycle will be 1 to 4 year
              </Typography> */}
            </Box>
          </Button>

          {/* Corporate Card/Button */}
          <Button
            variant="outlined"
            onClick={() => {
              setSelectedType("Corporate");
              setOpenTypeDialog(false);
              setOpen(true);
            }}
            sx={(theme) => ({
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1.5,
              p: 3,
              borderRadius: "12px",
              textTransform: "none",
              borderColor: theme.palette.mode === 'dark' ? 'rgba(148,163,184,0.2)' : 'rgba(160, 198, 232, 0.5)',
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(30,41,59,0.5)' : 'rgba(241, 245, 249, 0.5)',
              color: theme.palette.text.primary,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                borderColor: theme.palette.primary.main,
                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(29, 78, 216, 0.15)' : 'rgba(29, 78, 216, 0.06)',
                transform: "translateY(-4px)",
                boxShadow: theme.palette.mode === 'dark'
                  ? '0 8px 20px rgba(0,0,0,0.4)'
                  : '0 8px 20px rgba(29, 78, 216, 0.08)',
              },
            })}
          >
            <BusinessIcon sx={{ fontSize: 44, color: "primary.main" }} />
            <Box>
              <Typography variant="subtitle1" fontWeight={700}>
                Corporate
              </Typography>
              {/* <Typography variant="caption" color="text.secondary">
                Replacement cycle will be 1 to 5 year
              </Typography> */}
            </Box>
          </Button>
        </DialogContent>
      </Dialog>

      {open && (
        <FleetCsvUpload
          handleClose={handleClose}
          open={open}
          classes={classes}
          defaultColDef={defaultColDef}
          handleRowSelection={handleRowSelection}
          addButtonDisabled={addButtonDisabled}
          setAddButtonDisabled={setAddButtonDisabled}
          setRowDataCsv={setRowDataCsv}
          columnFinal={columnFinal}
          newRowData={newRowData}
          setRows={setRows}
          setFile={setFile}
          file={file}
          uploadType={selectedType}
        />
      )}
      {deleteOpen && (
        <DeleteDialog
          open={deleteOpen}
          setOpen={() => setDeleteOpen(false)}
          deleteApi={() => handleDelete()}
        />
      )}
      {popupBlock && (
        <PopupBlock
          open={popupBlock}
          setOpen={() => setPopupBlock(false)}
          navigationRouteNext={"/strategic-replacement-plan"}
          selectedNavStyle={sidebarMenu.replacement}
          columnChangeData={movableColumnData}
          pageName={PageNameConstant.fleetList}
        />
      )}
    </Box>
  );
};
